export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[720px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">联系我们</h2>
            <p className="mt-3 text-sm text-foreground-500">有任何问题或建议？欢迎与我们取得联系</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10">
            <div className="bg-background-100 rounded-xl p-6 text-center border border-background-200/70 cursor-pointer hover:border-accent-300/50 transition-colors">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-accent-100">
                <i className="ri-mail-line text-xl text-accent-600"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 mb-1">邮箱联系</h3>
              <p className="text-xs text-foreground-500">support@mogumovies.com</p>
            </div>
            <div className="bg-background-100 rounded-xl p-6 text-center border border-background-200/70 cursor-pointer hover:border-primary-300/50 transition-colors">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-primary-100">
                <i className="ri-wechat-line text-xl text-primary-600"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 mb-1">微信公众号</h3>
              <p className="text-xs text-foreground-500">蘑菇影视官方</p>
            </div>
            <div className="bg-background-100 rounded-xl p-6 text-center border border-background-200/70 cursor-pointer hover:border-secondary-300/50 transition-colors">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-secondary-100">
                <i className="ri-feedback-line text-xl text-secondary-600"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 mb-1">意见反馈</h3>
              <p className="text-xs text-foreground-500">在线提交反馈意见</p>
            </div>
          </div>

          <div className="bg-background-100 rounded-2xl p-6 md:p-8 border border-background-200/70">
            <h3 className="text-base font-semibold text-foreground-800 mb-6 text-center">发送消息</h3>
            <form className="space-y-4" onSubmit={(e) => e.preventDefault()}>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-medium text-foreground-600 mb-1.5">您的称呼</label>
                  <input
                    type="text"
                    name="name"
                    className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-200 bg-background-50 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                    placeholder="请输入您的称呼"
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium text-foreground-600 mb-1.5">电子邮箱</label>
                  <input
                    type="email"
                    name="email"
                    className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-200 bg-background-50 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                    placeholder="请输入您的邮箱"
                  />
                </div>
              </div>
              <div>
                <label className="block text-xs font-medium text-foreground-600 mb-1.5">消息内容</label>
                <textarea
                  name="message"
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-200 bg-background-50 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                  placeholder="请输入您想说的话（最多500字）"
                ></textarea>
              </div>
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="anti-spam-field"
              />
              <button
                type="submit"
                className="w-full py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-lg transition-colors cursor-pointer whitespace-nowrap text-sm"
              >
                发送消息
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}